/**
 * Location query-string helpers shared across the events/booking/inquiry flows.
 */

/**
 * Build location query string from zip and/or lat/lng params.
 * Returns a string like "zip=10001" or "lat=40.71&lng=-74.00" or "zip=10001&lat=40.71&lng=-74.00".
 */
export function buildLocationParams(params: { zip?: string; lat?: string; lng?: string; q?: string }): string {
  const parts: string[] = [];
  if (params.zip) parts.push(`zip=${encodeURIComponent(params.zip)}`);
  if (params.lat && params.lng) {
    parts.push(`lat=${encodeURIComponent(params.lat)}`);
    parts.push(`lng=${encodeURIComponent(params.lng)}`);
  }
  if (params.q) parts.push(`q=${encodeURIComponent(params.q)}`);
  return parts.join('&');
}
